import { createAction, props } from "@ngrx/store";

export const UPDATE_MAINTENANCE = '[MAINTENANCE Component] Update maintenance';

export const updateMaintenance = createAction(
    UPDATE_MAINTENANCE,
    props<{ isMaintenance: boolean }>()
);